import React, { useEffect, useState } from 'react';
import Wrapper from "layout/Wrapper/Wrapper";
import styles from "styles/pages/RangeInformation.module.scss";
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { FormControl, Grid, MenuItem, Select } from '@mui/material';
import CustomInputNoLabel from 'ui/CustomInputNoLabel/CustomInputNoLabel';
import CustomInput from 'ui/CustomInput/CustomInput';
import CustomButton from 'ui/CustomButton/CustomButton';
import { classification } from 'json/constants';
import { country_list, state_list } from 'redux/RangeInfoSlice';
import { useDispatch } from 'react-redux';
import { decryptSecretKey, normalizeUrl } from 'services/utils';
import useNotiStack from 'hooks/useNotistack';
import validationText from 'json/message/Validation';
import SideBarActions from 'layout/SideBarActions/SideBarActions';
import * as yup from "yup";
import { useNavigate } from 'react-router-dom';
import { course_clubhouse_Lat_Lon_create, course_create, course_layout_list, course_mapping_gps_update } from 'redux/CourseMapSlice';
import { useCourseGPSMappingData } from 'hooks/CourseMapDetails';
import wrapperStyles from "styles/pages/Map1.module.scss";



export default function CourseInformation() {
  const dispatch = useDispatch();
  const secret_Key = decryptSecretKey();
  const navigate = useNavigate();
  const courseGPSMapping = useCourseGPSMappingData();
  const courseGPSMappingData = courseGPSMapping?.GPSList;
  let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);

  const {toastSuccess , toastError } = useNotiStack();
  const profileDetails = JSON.parse(localStorage.getItem("profile_data"));
  const id_adminuser = localStorage.getItem("id_adminuser");


  const [loadingCountryList, setLoadingCountryList] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [idcountryValue, setIdCountryValue] = useState();
  const [loadingStateList, setLoadingStateList] = useState(false);
  const [stateData, setStateData] = useState([]);
  const [courseLayout, setCourseLayout] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [sideBarExpanded, setSideBarExpanded] = useState();
  

  const schema = yup.object().shape(
    {
      courseName: yup
        .string()
        .trim()
        .required("Enter a Course Name")
        .max(50, "Course name must be 50 characters or fewer"),
        // .min(3, validationText.error.rangeNameLenErr),
      numberOfHoles: yup.string().required("Select a layout"),
      address1: yup.string().trim().required(),
      city: yup.string().trim().required(),
      country: yup.string().required(),
      zip: yup
         .string()
         .trim().max(10),
      // phone: yup
      // .number().min(2)
      // .max(15),
      // website: yup.string()
      email: yup.string().email(),
    },
  );

  const {
    handleSubmit,
    control,
    getValues,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = async (data) => {
setSubmitLoading(true);

dispatch(course_create({
  body:{
    courseName: data?.courseName.trim(),
    id_layoutHoles: Number(data?.numberOfHoles),
    address1: data?.address1.trim(),
    address2: data?.address2?.trim(),
    city: data?.city?.trim(),
    id_state: data?.state,
    otherState: data?.otherState,
    zipCode: data?.zip,
    id_country: idcountryValue ? idcountryValue : 840,
    phone: data?.phone,
    url: normalizeUrl(data?.website),
    email: data?.email,
    class: data?.classification
  },
  user: {
    secretKey: secret_Key,
    userName: profileDetails?.username,
  },
})).then((res)=> {
  if (res?.payload?.data?.Status === 1) {
    toastSuccess(res?.payload?.data?.ErrorMessage);
    if(data?.clubHouseLatitude && data?.clubHouseLongitude){

      dispatch(
        course_mapping_gps_update({
          body: {
            id_course: res?.payload?.data?.id_courseInt,
            clubLat: Number(data.clubHouseLatitude),
            clubLon: Number(data.clubHouseLongitude),
            // id_courseLayout: 2,
            GPSList: temp_courseGPSMappingData,
          },
          user: {
            secretKey: secret_Key,
            userName: profileDetails?.username,
          },
        })
      );
    }

    setSubmitLoading(false);
    navigate("/coursemap")
  }else{
    setSubmitLoading(false);
    
  if(res?.payload?.data?.Status === 401){
      res?.payload?.data?.violationDetailsList.map((error)=> (
      toastError(`${error.fieldName} ${error.message}`)
    ))
  }else{
    toastError("Something Went wrong, Please try again.");
  }
  }
})

  }

  const handleSelectMenu = (e, selectedMenu) => {
    setIdCountryValue(selectedMenu?.id_country);
    setLoadingStateList(true);
    fetchStateList(selectedMenu?.id_country);
  };

  useEffect(() => {
    setLoadingCountryList(true);
    dispatch(
      country_list({
        body: {
          // id_adminuser: id_adminuser,
          // id_continent: "NA",
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setCountryData(res?.payload?.data?.countryList);
        setLoadingCountryList(false);
      } else {
        // setLoadingCountryList(false);
        toastError("Something went wrong");
      }
    });
  }, []);

  useEffect(() => {
    reset({
      country: 840,
    });
    fetchStateList(840);
  }, []);

  const fetchStateList = (id_country) => {
    setValue("state", undefined);
    dispatch(
      state_list({
        body: {
          id_adminuser: id_adminuser,
          id_country: id_country || 840, // static id_country for usa
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setStateData(res?.payload?.data?.stateList);
        setLoadingStateList(false);
      } else {
        setLoadingStateList(false);
      }
    });
  };

  useEffect(()=>{
    dispatch(
      course_layout_list({
        body: {
          // id_adminuser: id_adminuser,
          // id_continent: "NA",
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setCourseLayout(res?.payload?.data?.courseLayoutArray)
      } else {
        // setLoadingCountryList(false);
        toastError("Something went wrong");
      }
    });
  },[])

  const handleGoToPrev = ()=>{
    navigate("/coursemap")
  }
  
  return (
    <div className="main_wraper">
     <Wrapper isHeader={true} headerTitle={'COURSE MAP'}>
      <div
            className={
              sideBarExpanded
                ? `${wrapperStyles.main_wrapper_flex}`
                : `${wrapperStyles.main_wrapper_flex} ${wrapperStyles.main_wrapper_flex_open}`
            }
          >
            <div className={wrapperStyles.main_left}>
              <div className={styles.sideBar}>
                <SideBarActions 
                  form='courseInfo'
                  onCancelClick={handleGoToPrev}
                  toggleSideBar={() => setSideBarExpanded(prev => !prev)} />
              </div>
            </div>
          <div className={wrapperStyles.main_rgt}>
            <div className={styles.range_sec}>
              <form id='courseInfo' onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={0}>
                  <Grid item md={6} xs={12}>
                    <div className={styles.range_sec_box}>
                      <div className={styles.range_head}>
                      <p>Course Information</p>
                      </div>

                      <div className={`${styles.range_form} ${styles.range_form_cmn}`}>
                              <div className={styles.formSec}>
                                <Grid container spacing={0}>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={4} md={4}>
                                          <label>Course Name*</label>
                                        </Grid>
                                        <Grid item xs={7} md={7}>
                                          {errors?.courseName?.message  && (
                                            <p className={styles.errorMsg}>
                                              {errors.courseName.message}
                                            </p>
                                        )}
                                        </Grid>
                                      </Grid>
                                      <Controller
                                        control={control}
                                        name="courseName"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            // disabled={submitLoading}
                                            // label="Range Name *"
                                            // error={Boolean(errors?.rangeName)}
                                            // helperText={errors?.rangeName?.message}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                      <Grid item xs={5} md={5}>
                                        <label>Number of holes*</label>
                                      </Grid>
                                      <Grid item xs={7} md={7}>
                                          {errors?.numberOfHoles?.message  && (
                                            <p className={styles.requiredContent}>
                                              {errors.numberOfHoles.message}
                                            </p>
                                          )}
                                        </Grid>
                                      </Grid>
                                      
                                      <FormControl sx={{ m: 1, minWidth: 120 }}>
                                        <Controller
                                          control={control}
                                          name="numberOfHoles"
                                          
                                          render={({ field: { onChange, value } }) => (
                                            <Select 
                                              displayEmpty
                                              defaultValue=""
                                              id="demo-simple-select"
                                              onChange={onChange}
                                              // value={value}
                                              value={value ? value : ""}
                                            >
                                              <MenuItem value="" disabled>
                                                Select Layout
                                              </MenuItem>
                                              {courseLayout?.slice(1).map((e) => {
                                                return (
                                                  <MenuItem
                                                    key={e?.id_layout}
                                                    value={e?.id_layout}
                                                  >
                                                    {e?.name}
                                                  </MenuItem>
                                                );
                                              })}
                                            </Select>
                                          )}
                                        />
                                      </FormControl>
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={5} md={5}>
                                          <label>ADDRESS 1*</label>
                                        </Grid>
                                        <Grid item xs={7} md={7}>
                                          {errors.address1 && (
                                            <p className={styles.requiredContent}>
                                              {validationText.error.address1}
                                            </p>
                                          )}
                                        </Grid>
                                      </Grid>
                                      <Controller
                                        control={control}
                                        name="address1"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            // disabled={submitLoading}
                                            // error={Boolean(errors?.address1)}
                                            // helperText={errors?.address1?.message}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      {/* <label>ADDRESS 2</label> */}
                                      <Controller
                                        control={control}
                                        name="address2"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInput
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            label="ADDRESS 2"
                                            // disabled={submitLoading}
                                            // error={Boolean(errors?.address2)}
                                            // helperText={errors?.address2?.message}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={5} md={5}>
                                          <label>CITY *</label>
                                        </Grid>
                                        <Grid item xs={7} md={7}>
                                          {errors.city && (
                                            <p className={styles.requiredContent}>
                                              {validationText.error.city}
                                            </p>
                                          )}
                                        </Grid>
                                      </Grid>
                                      <Controller
                                        control={control}
                                        name="city"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            label="CITY *"
                                            // disabled={submitLoading}
                                            // error={Boolean(errors?.city)}
                                            // helperText={errors?.city?.message}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <label>STATE</label>
                                      <FormControl sx={{ m: 1, minWidth: 120 }}>

                                      <Controller
                                              control={control}
                                              name="state"
                                            
                                              render={({
                                                field: { onChange, value },
                                              }) => (
                                                <>
                                                  {/* {stateData &&
                                                  stateData?.length !== 0 ? ( */}
                                                    <Select 
                                                      displayEmpty
                                                      onChange={onChange}
                                                      defaultValue={value}
                                                      value={value ? value : ""}
                                                      // value={
                                                      //   value !== undefined && value
                                                      // }
                                                    >
                                                      <MenuItem value="" disabled>
                                                {stateData?.length !== 0 ? "Select State" : " - State not available -"}    
                                                    </MenuItem>
                                                      {stateData?.map((e, id) => {
                                                        return (
                                                          <MenuItem
                                                            value={e?.id_state}
                                                            key=""
                                                          >
                                                            {e?.stateFull}
                                                          </MenuItem>
                                                        );
                                                      })}
                                                    </Select>
                                                  {/* ) : (
                                                    <Select>
                                                      <MenuItem disabled>
                                                        - State not available -
                                                      </MenuItem>
                                                    </Select>
                                                  )} */}
                                                </>
                                              )}
                                            />
                                        
                                        {/* {getValues("country") !== undefined ? (
                                          <>
                                            {loadingStateList && (
                                              <BackdropLoader open={true} />
                                            )}
                                            <Controller
                                              control={control}
                                              name="state"
                                            
                                              render={({
                                                field: { onChange, value },
                                              }) => (
                                                <>
                                                  {stateData &&
                                                  stateData?.length !== 0 ? (
                                                    <Select 
                                                      displayEmpty
                                                      onChange={onChange}
                                                      defaultValue={value}
                                                      value={value ? value : ""}
                                                      // value={
                                                      //   value !== undefined && value
                                                      // }
                                                    >
                                                      <MenuItem value="" disabled>
                                                    Select State
                                                    </MenuItem>
                                                      {stateData.map((e, id) => {
                                                        return (
                                                          <MenuItem
                                                            value={e?.id_state}
                                                            key=""
                                                          >
                                                            {e?.stateFull}
                                                          </MenuItem>
                                                        );
                                                      })}
                                                    </Select>
                                                  ) : (
                                                    <Select>
                                                      <MenuItem disabled>
                                                        - State not available -
                                                      </MenuItem>
                                                    </Select>
                                                  )}
                                                </>
                                              )}
                                            />
                                          </>
                                        ) : (
                                          <Select>
                                            <MenuItem disabled>
                                              - Select a country first -
                                            </MenuItem>
                                          </Select>
                                        )} */}
                                        {/* {errors.state && <p className={styles.requiredContent}>{validationText.error.state}</p> } */}
                                      </FormControl>
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      {/* <label>OTHER STATE</label> */}
                                      <Controller
                                        control={control}
                                        name="otherState"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInput
                                            label="OTHER STATE"
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            // disabled={submitLoading}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                    <label>ZIP CODE</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                          {errors.zip && (
                                            <p className={styles.requiredContent}>
                                              {validationText.error.zip}
                                            </p>
                                          )}
                                        </Grid>
                                    </Grid>
                                      <Controller
                                        control={control}
                                        name="zip"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                            label="ZIP CODE"
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            // disabled={submitLoading}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={5} md={5}>
                                          <label>COUNTRY *</label>
                                        </Grid>
                                        <Grid item xs={7} md={7}>
                                          {/* {errors.country && (
                                            <p className={styles.requiredContent}>
                                              {validationText.error.country}
                                            </p>
                                          )} */}
                                        </Grid>
                                      </Grid>

                                      <FormControl sx={{ m: 1, minWidth: 120 }}>
                                        {countryData && countryData?.length !== 0 ? (
                                          <Controller
                                            control={control}
                                            name="country"
                                            // {...register("country")}
                                            render={({
                                              field: { onChange, value },
                                            }) => (
                                              <Select
                                                id="demo-simple-select"
                                                onChange={onChange}
                                                // value={value}
                                                value={value ? value : ""}
                                              >
                                                {countryData &&
                                                  countryData.map((e) => {
                                                    return (
                                                      <MenuItem
                                                        value={e.id_country}
                                                        // onClick={handleSelectMenu}
                                                        onClick={(event) =>
                                                          handleSelectMenu(event, e)
                                                        }
                                                      >
                                                        {e?.countryFull}
                                                      </MenuItem>
                                                    );
                                                  })}
                                              </Select>
                                            )}
                                          />
                                        ) : (
                                          <Select>
                                            <MenuItem disabled>
                                              - Network Error -
                                            </MenuItem>
                                          </Select>
                                        )}
                                      </FormControl>
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>PHONE NUMBER</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                          {/* {errors.phone && (
                                            <p className={styles.requiredContent}>
                                              {errors.phone.message}
                                            </p>
                                          )} */}
                                        </Grid>
                                    </Grid>
                                      <Controller
                                        control={control}
                                        name="phone"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                            // label="PHONE NUMBER"
                                            placeholder=""
                                            type="number"
                                            value={value}
                                            onChange={onChange}
                                            onKeyPress={(e) => {
                                              if (
                                                e.key === "e" ||
                                                e.key === "E" ||
                                                e.key === "-"
                                              ) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onPaste={(e) => {
                                              e.preventDefault();
                                              return false;
                                            }}
                                            // disabled={submitLoading}
                                            // error={Boolean(errors?.phone)}
                                            // helperText={errors?.phone?.message}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                    <label>WEBSITE</label>
                                    </Grid>
                                    {/* <Grid item xs={7} md={7}>
                                          {errors.email && (
                                            <p className={styles.requiredContent}>
                                              {errors.email.message}
                                            </p>
                                          )}
                                        </Grid> */}
                                    </Grid>
                                      <Controller
                                        control={control}
                                        name="website"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                            // label="WEBSITE"
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            // disabled={submitLoading}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                    <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                    <label>Email</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                          {errors.email && (
                                            <p className={styles.requiredContent}>
                                              {errors.email.message}
                                            </p>
                                          )}
                                        </Grid>
                                    </Grid>
                                      {/* <FormControl sx={{ m: 1, minWidth: 120 }}> */}
                                        <Controller
                                          control={control}
                                          name="email"
                                          render={({ field: { onChange, value } }) => (
                                            <CustomInputNoLabel
                                            // label="Email"
                                            placeholder=""
                                            type="text"
                                            value={value}
                                            onChange={onChange}
                                            // disabled={submitLoading}
                                          />
                                          )}
                                        />
                                        {/* {errors.status && <p className={styles.requiredContent}></p> } */}
                                      {/* </FormControl> */}
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={5} md={5}>
                                          <label>ClubHouse Latitude</label>
                                        </Grid>
                                        <Grid item xs={7} md={7}>
                                          {/* {errors.latitude && (
                                            <p className={styles.requiredContent}>
                                              {validationText.error.latitude}
                                            </p>
                                          )} */}
                                        </Grid>
                                      </Grid>
                                      <Controller
                                        control={control}
                                        name="clubHouseLatitude"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                          placeholder=""
                                          type="number"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                          onKeyPress={(e) => {
                                            if (e.key === "e" || e.key === "E") {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={5} md={5}>
                                          <label>ClubHouse Longitude</label>
                                        </Grid>
                                        <Grid item xs={7} md={7}>
                                          {/* {errors.longitude && (
                                            <p className={styles.requiredContent}>
                                              {validationText.error.longitude}
                                            </p>
                                          )} */}
                                        </Grid>
                                      </Grid>
                                      <Controller
                                        control={control}
                                        name="clubHouseLongitude"
                                        render={({ field: { onChange, value } }) => (
                                          <CustomInputNoLabel
                                          placeholder=""
                                          type="number"
                                          value={value}
                                          onChange={onChange}
                                          // disabled={submitLoading}
                                          onKeyPress={(e) => {
                                            if (e.key === "e" || e.key === "E") {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                        )}
                                      />
                                    </div>
                                  </Grid>
                                  <Grid item sm={6} xs={12}>
                                    <div className={styles.formGroup}>
                                      <label>CLASSIFICATION</label>
                                      <FormControl sx={{ m: 1, minWidth: 120 }}>
                                        <Controller
                                          control={control}
                                          name="classification"
                                          render={({ field: { onChange, value } }) => (
                                            <Select  
                                              displayEmpty
                                              defaultValue=""
                                              id="demo-simple-select"
                                              onChange={onChange}
                                              // value={value}
                                              value={value ? value : ""}
                                            >
                                              <MenuItem value="" disabled>
                                                Select Classification
                                              </MenuItem>
                                              {classification.map((e) => {
                                                return (
                                                  <MenuItem
                                                    key={e?.id}
                                                    value={e?.value}
                                                  >
                                                    {e?.label}
                                                  </MenuItem>
                                                );
                                              })}
                                            </Select>
                                          )}
                                        />
                                      </FormControl>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </div>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  )
}
